import { map } from "rxjs/operators";
import { GET, POST } from "../../../module/services/fetch";

export const fetchUserTemporaryEntitlements = (payload: any) => {
  const { body, sortBy } = payload;
  return POST(
    `temporary/user/entitlement/paginated${
      sortBy && sortBy.length > 0
        ? `?sortField=${sortBy[0].id}&sortOrder=${
            sortBy[0].desc ? "desc" : "asc"
          }`
        : ""
    }`,
    body
  ).pipe(map((response: any) => response));
};

export const sendTemporaryAbilitationRequest = (body: FormData) =>
  POST(
    "temporary/request",
    body,
    undefined,
    undefined,
    undefined,
    "multipart/form-data"
  ).pipe(map((response: any) => response));

export const getFieldsFromSelectedTemporaryAbilitation = (payload: {
  entitlementId: string;
  identitySystemId: string;
}) => {
  const { entitlementId, identitySystemId } = payload;
  return GET(
    `temporary/user/entitlement/${entitlementId}/fields?identitySystemId=${identitySystemId}`
  ).pipe(map((response: any) => response));
};

export const getUserEntitlementAndBusinessRoleRequest = (userId: string) =>
  POST(`entitlements/searchByUserId?businessRole=false`, [userId]).pipe(
    map((response: any) => response)
  );

export const getEmergencyCheckService = () =>
  GET("temporary/hasEmeEntitlement").pipe(map((response: any) => response));

export const checkOwnedRequirementEntitlements = (configId: string) =>
  GET(`temporary/checkRequirements/${configId}`).pipe(
    map((response: any) => response)
  );

export const getEmergencyEntitlementsService = (payload: any) => {
  const { body, sortBy } = payload;
  return POST(
    `temporary/user/emeEntitlement/paginated${
      sortBy && sortBy.length > 0
        ? `?sortField=${sortBy[0].id}&sortOrder=${
            sortBy[0].desc ? "desc" : "asc"
          }`
        : `?sortField=created_on&sortOrder=desc`
    }`,
    body
  ).pipe(map((response: any) => response));
};
